import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  defaultImage: string = 'assets/image.svg';
}